import React from 'react';

function LocationIndicator({ location }) {
  if (!location) return null;

  return (
    <div className="location-indicator">
      <span className="location-icon-small">📍</span>
      <span>GPS Activo</span>
    </div>
  );
}

export default LocationIndicator;
